import { v4 as uuidv4 } from "uuid";
export class HighlightModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.publishDateAsString = "";
        this.highlightText = "";
        this.status = "";
        this.isEditable = false;
        this.isArchive = false;
        this.isDeletable = false;
    }
}
export default class Highlight extends HighlightModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
